import {useCallback, useEffect, useMemo, useState} from 'react';

export const useResizeObserver = () => {
  const [dimensions, setDimensions] = useState<DOMRectReadOnly | null>(null);
  const [element, setElement] = useState<HTMLDivElement | null>(null);
  const [offsetTop, setOffsetTop] = useState<number | null>(null);

  const callback: ResizeObserverCallback = useCallback(
    (entries: ResizeObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.target === element) {
          setDimensions(entry.contentRect);
          setOffsetTop(element.offsetTop);
        }
      });
    },
    [setDimensions, element, setOffsetTop]
  );
  const observer = useMemo(() => new ResizeObserver(callback), [callback]);

  const refCallback = useCallback(
    (node: HTMLDivElement | null) => {
      if (node) {
        setElement(node);
        observer.observe(node);
      }
    },
    [observer]
  );

  useEffect(() => {
    return () => {
      if (element) {
        observer.unobserve(element);
      } else {
        observer.disconnect();
      }
    };
  }, [observer, element]);
  return {dimensions, refCallback, offsetTop};
};
